import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center" data-testid="not-found-page">
      <div className="text-center px-4">
        <p className="text-xs uppercase tracking-[0.3em] text-[var(--brand-orange)] mb-3">404</p>
        <h1 className="text-5xl sm:text-7xl font-black mb-4">
          Página no <span className="font-wild text-gradient-brand">encontrada</span>
        </h1>
        <p className="text-white/65 mb-8 max-w-md mx-auto">
          La página que buscas no existe o fue movida.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-[var(--brand-orange)] text-[#58677A] rounded-full px-6 py-3 font-bold hover:bg-[var(--brand-amber)] transition"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
